import { success, info, neutral, error } from '../../style/colors';

const getStatus = (statusCode, t) => {
  switch (statusCode) {
    case 0:
      return {
        text: t('closed'),
        color: success.dark,
      };

    case -1:
      return {
        text: t('confirmed'),
        color: success.base,
      };
    case -2:
      return {
        text: t('inProgress'),
        color: info.base,
      };
    case -3:
      return {
        text: t('canceled'),
        color: neutral[500],
      };
    default:
      return {
        text: t('error'),
        color: error.base,
      };
  }
};

export default getStatus;
